import React from 'react';
import { useTrackableLink } from '@noths/polaris-client-react-hooks';
import {
  facebookURL,
  IconFacebook,
  IconInstagram,
  IconPinterest,
  IconTiktok,
  instagramURL,
  pinterestURL,
  tiktokURL,
} from '@noths/polaris-client-ribbons-design-system';

import * as styles from './FooterSocialMedia.styles';
import { FooterPromo } from 'client-site-chrome-ui/components/molecules/FooterPromo/FooterPromo';

interface SocialMediaLinkProps {
  children: React.ReactNode;
  href: string;
  title: string;
}

const SocialMediaLink = ({ children, href, title }: SocialMediaLinkProps) => {
  const { trackLinkClick, trackLinkMouseDown } = useTrackableLink();
  const trackingEvent = {
    event: 'custom_event',
    event_action: 'Social click',
    event_category: 'Footer',
    event_label: title,
  };

  return (
    <a
      css={styles.icon}
      href={href}
      onClick={trackLinkClick(trackingEvent)}
      onMouseDown={trackLinkMouseDown(trackingEvent)}
      rel="noreferrer"
      target="_blank"
      title={title}
    >
      {children}
    </a>
  );
};

export const FooterSocialMedia = () => {
  return (
    <FooterPromo
      intro="Find even more inspiration and see behind the scenes"
      title="Follow us on social"
    >
      <div css={styles.container}>
        <SocialMediaLink href={facebookURL} title="Facebook">
          <IconFacebook css={styles.icon} />
        </SocialMediaLink>
        <SocialMediaLink href={tiktokURL} title="Tiktok">
          <IconTiktok css={styles.icon} />
        </SocialMediaLink>
        <SocialMediaLink href={pinterestURL} title="Pinterest">
          <IconPinterest css={styles.icon} />
        </SocialMediaLink>
        <SocialMediaLink href={instagramURL} title="Instagram">
          <IconInstagram css={styles.icon} />
        </SocialMediaLink>
      </div>
    </FooterPromo>
  );
};
